module.exports = __webpack_public_path__ + "site/img/hkid.1ce5e83c.png";